export default {
    primary: '#dc0714',
}
